const JVWEB_HOSTNAMES = ['seo.jvweb.com', 'jvweb.local', 'local.jvweb.test'];
const ADSUP_HOSTNAMES = ['local.adsup.test', 'red-hill-003d1da03.5.azurestaticapps.net'];

export function isJvwebBrand() {
    return JVWEB_HOSTNAMES.includes(window.location.hostname);
}

export function isAdsupBrand() {
    return ADSUP_HOSTNAMES.includes(window.location.hostname);
}

export function getTheme() {
    if (isJvwebBrand()) return 'jvweb';
    return 'adsup';
}

export function getBrandName() {
    return isJvwebBrand() ? 'JVWEB Insights' : 'Clustaar Insights';
}

export function getBrandConfig() {
    const isJvweb = isJvwebBrand();
    const theme = getTheme();
    return {
        name: isJvweb ? 'JVWEB Insights' : 'Clustaar Insights',
        shortName: isJvweb ? 'JVWEB' : 'Clustaar',
        logoPath: isJvweb ? '/logo-jvweb.svg' : null,
        faviconPath: isJvweb ? '/favicon-jvweb.ico' : '/favicon.ico',
        isJvweb,
        theme
    };
}

export function applyTheme() {
    const theme = getTheme();
    document.documentElement.setAttribute('data-theme', theme);
}

export function updateDocumentBranding() {
    const brand = getBrandConfig();
    document.title = brand.name;

    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
        favicon.href = brand.faviconPath;
    }

    applyTheme();
}
